import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { Box, Button, HStack, Text, useTheme, VStack } from '@chakra-ui/react'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as xlsx from 'xlsx'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import ProgressBar from '../ProgressBar/ProgressBar'
export default function FileUploader({ handleFile }) {
  const theme = useTheme()
  const { texts } = useLabels()
  const [loading] = useState(false)
  const [fileName, setFileName] = useState('')

  const clear = () => {
    document.getElementById('upload').value = ''
    handleFile(null)
    setFileName('')
  }

  const readUploadFile = useCallback(
    (e) => {
      e.preventDefault()
      if (e.target.files) {
        setFileName(e.target.files[0]?.name || '')
        const reader = new FileReader()
        reader.onload = (event) => {
          const data = event.target.result
          const workbook = xlsx.read(data, {
            type: 'array',
          })
          const sheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[sheetName]
          const json = xlsx.utils.sheet_to_json(worksheet)
          handleFile(json)
        }
        reader.readAsArrayBuffer(e.target.files[0])
        document.getElementById('upload').value = ''
      }
    },
    [handleFile],
  )

  return (
    <Box backgroundColor={theme.colors.gray[50]} w="25vw">
      <VStack padding="8px" spacing="15px" alignItems="flex-start">
        <HStack justifyContent="space-between" w="90%">
          <Text variant="body2" pt="8px">
            {!fileName ? 'No se han cargado archivos' : fileName}
          </Text>
          {fileName && (
            <Box mt="10px" w="20px">
              <Button
                onClick={clear}
                cursor="pointer"
                h="20px"
                w="20px"
                variant="gray"
              >
                <FontAwesomeIcon icon={faXmark} />
              </Button>
            </Box>
          )}
        </HStack>
        <ProgressBar loading={loading} hasContent={!!fileName} />
        <HStack w="100%" justifyContent="space-between">
          <Box>
            <input
              hidden
              type="file"
              name="upload"
              id="upload"
              onChange={readUploadFile}
            />
            <Button
              as="label"
              cursor="pointer"
              htmlFor="upload"
              variant="white"
            >
              {texts.choose_file}
            </Button>
          </Box>
        </HStack>
      </VStack>
    </Box>
  )
}

FileUploader.propTypes = {
  handleFile: PropTypes.func,
}
